import logo from '../assets/png/limas.jpg';

export const headerData = {
    name: 'Cremería Limas',
    tagline: 'Queso · Crema · Mantequilla',
    description: 'El mejor queso, crema y mantequilla del mercado. Hecho con dedicación y calidad desde 2019.',
    image: logo,
}
